/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable react/jsx-no-target-blank */
import { scope, sendCodeTimeKey } from '@/config/base';
import { getLocalStorage, setLocalStorage } from '@/utils/cookies';
import { MailOutlined, MobileOutlined } from '@ant-design/icons';
import { Button, Checkbox, Form, Input, message } from '@sinohealth/butterfly-ui-components';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { sendPhoneCode } from '../../http';
import { validIsMobile } from '../../utils';
import SubmitButton from '../SubmitButton';
import styles from './index.less';

const { useForm } = Form;
const sendCodeTimeOut = 60;

type SmsLoginProps = {
  onLogin?: (val: { channel: string; credentials: string }, bol?: boolean) => void;
  serviceProtocolUrl?: string; // 服务协议
  privacyProtocolUrl?: string; // 隐私协议
  serviceText?: string;
  privacyText?: string;
  protocolBool?: boolean; // 是否展示协议
  onBack?: (v: string) => void;
};

/** 绑定手机号 */
const BindMobile: React.FC<SmsLoginProps> = (props) => {
  const {
    onLogin,
    protocolBool,
    serviceProtocolUrl,
    serviceText,
    privacyProtocolUrl,
    privacyText,
    onBack,
  } = props;
  const [form] = useForm();
  const location = useLocation();

  const [phoneNo, setPhoneNo] = useState('');
  const [canSendCode, setCanSendCode] = useState(true);
  const [timeLeft, setTimeLeft] = useState(0);
  const [channel, setChannel] = useState('wx');

  const onFinish = async (values: any) => {
    console.log('Success:', values);
    onLogin && onLogin({ channel: 'phone', scope, ...values });
  };

  const validPhoneNo = (rule: any, value: any) => {
    if (value === '') {
      return Promise.reject('手机号码不能为空');
    }
    if (!validIsMobile(value)) {
      return Promise.reject('手机号格式不正确');
    }
    return Promise.resolve();
  };

  const agreementValid = (rule: any, val: any) => {
    return val ? Promise.resolve() : Promise.reject();
  };

  const getErrorMessage = () => {
    const errors = form.getFieldsError();
    let errorMessage: string[] = [];
    errors.forEach((item) => {
      errorMessage = errorMessage.concat(item.errors);
    });
    const errorMsg = errorMessage.reverse().pop();
    errorMsg && message.error(errorMsg);
    console.log(errors);
  };

  const handleSendSmsCode = async () => {
    if (!phoneNo) {
      message.error('手机号码不能为空');
      return;
    }
    try {
      await sendPhoneCode(phoneNo);
      setLocalStorage(sendCodeTimeKey, Date.now());
      setTimeLeft(sendCodeTimeOut);
      setCanSendCode(false);
    } finally {
      console.log(1);
    }
  };

  useEffect(() => {
    const time = getLocalStorage(sendCodeTimeKey);
    if (time) {
      const timeLeftData = Math.floor((Date.now() - time) / 1000);
      const isCan = timeLeftData > sendCodeTimeOut;
      setCanSendCode(isCan);
      if (!isCan) {
        setTimeLeft(sendCodeTimeOut - timeLeftData);
      }
    }

    const query = new URLSearchParams(location.search);
    const param = query.get('channel') || 'wx';
    setChannel(param);
  }, []);

  useEffect(() => {
    if (timeLeft > 0) {
      setCanSendCode(false);
      setTimeout(() => {
        setTimeLeft(timeLeft - 1);
      }, 900);
    } else {
      setCanSendCode(true);
    }
  }, [timeLeft]);

  return (
    <>
      <div className={styles['scan-title']}>
        {channel === 'wx' ? '微信扫码登录' : '企业微信扫码登录'}
      </div>
      <div className={styles['scan-tip']}>
        当前{channel === 'wx' ? '微信号' : '企业微信'}还未绑定全病程平台账号
        <div>验证账号进行绑定</div>
      </div>
      <Form
        name="basic"
        form={form}
        style={{ width: 312 }}
        size="large"
        onFinish={onFinish}
        onFinishFailed={getErrorMessage}
        autoComplete="off"
      >
        <Form.Item name="phone" noStyle rules={[{ validator: validPhoneNo }]}>
          <Input
            className={styles['custom-input']}
            autoComplete="new-password"
            maxLength={11}
            placeholder="输入手机号"
            prefix={<MobileOutlined />}
            onChange={(e) => setPhoneNo(e.target.value)}
          />
        </Form.Item>

        <Form.Item name="captcha" noStyle rules={[{ required: true, message: '验证码不能为空' }]}>
          <Input
            className={styles['custom-input']}
            prefix={<MailOutlined style={{ fontSize: 14 }} />}
            suffix={
              <Button
                type="link"
                size="small"
                style={{ fontSize: 16 }}
                disabled={!canSendCode || !validIsMobile(phoneNo)}
                onClick={() => handleSendSmsCode()}
              >
                {canSendCode ? '获取验证码' : `${timeLeft}s后重新获取`}
              </Button>
            }
            placeholder="输入短信验证码"
            autoComplete="off"
          />
        </Form.Item>

        <Form.Item noStyle wrapperCol={{ span: 24 }}>
          <div style={{ marginBottom: protocolBool ? 170 : 24 }} />
        </Form.Item>

        {protocolBool ? (
          <Form.Item
            noStyle
            name="protocol"
            valuePropName="checked"
            wrapperCol={{ span: 24 }}
            rules={[
              {
                validator: agreementValid,
                message: '请先阅读勾选服务条款与隐私协议',
              },
            ]}
          >
            <div style={{ marginBottom: 30 }} className={`${styles['small-margin']}`}>
              <Checkbox className={`${styles['small-font']}`}>
                阅读并同意《中康全病程患者管理服务平台》
              </Checkbox>
              <a
                href={serviceProtocolUrl || ''}
                className={`${styles['small-font']} ${styles.protocol}`}
                target="_blank"
              >
                {serviceText || '服务协议'}
              </a>
              <span className={styles['small-font']}>和</span>
              <a
                className={`${styles['small-font']} ${styles.protocol}`}
                href={privacyProtocolUrl || ''}
                target="_blank"
              >
                {privacyText || '隐私协议'}
              </a>
            </div>
          </Form.Item>
        ) : null}

        <Form.Item wrapperCol={{ span: 24 }}>
          <div style={{ display: 'flex' }}>
            <Button
              size="large"
              style={{ marginRight: 16 }}
              block
              onClick={() => {
                window.location.hash = '/login';
                onBack && onBack(channel);
              }}
            >
              返回登录
            </Button>
            {/* <Button
              className={`${styles['custom-btn']} ${!canLogin ? styles.disabled : ''}`}
              style={{ marginBottom: 16 }}
              type="primary"
              htmlType="submit"
              size="large"
              block
            >
              绑定
            </Button> */}
            <SubmitButton
              form={form}
              label="绑定"
              buttonProps={{
                type: 'primary',
                style: { marginBottom: 16 },
                size: 'large',
                block: true,
              }}
            />
          </div>
        </Form.Item>
      </Form>
    </>
  );
};

export default BindMobile;
